import { __decorate } from "tslib";
import { LitElement, html, css, } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let IANoTheaterAvailable = class IANoTheaterAvailable extends LitElement {
    constructor() {
        super(...arguments);
        this.identifier = '';
    }
    emitLoaded() {
        this.dispatchEvent(new CustomEvent('loadingStateUpdated', {
            detail: { loaded: true },
        }));
    }
    updated(changed) {
        if (changed.has('identifier')) {
            this.emitLoaded();
        }
    }
    get downloadUrl() {
        return `/download/${this.identifier}`;
    }
    render() {
        return html `
      <section>
        <h2>THERE IS NO PREVIEW AVAILABLE FOR THIS ITEM</h2>
        <p>
          This item does not appear to have any files that can be experienced on
          Archive.org. <br />
          Please download files in this item to interact with them on your
          computer.
        </p>
        <a href=${this.downloadUrl}>Show all files</a>
      </section>
    `;
    }
    static get styles() {
        return css `
      :host {
        color: var(--primaryTextColor, #fff);
        text-align: center;
      }
      section {
        width: 100%;
        margin: 5%;
        padding: 0 5%;
      }
      p {
        font-size: 1.4rem;
      }
      a {
        color: var(--primaryTextColor, #fff);
        background-color: rgb(25, 72, 128);
        min-height: 35px;
        cursor: pointer;
        line-height: normal;
        border-radius: 0.4rem;
        text-align: center;
        vertical-align: middle;
        font-size: 1.4rem;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        display: inline-block;
        padding: 0.85rem 1.2rem;
        border: 1px solid rgb(197, 209, 223);
        white-space: nowrap;
        appearance: auto;
        box-sizing: border-box;
        user-select: none;
        text-decoration: none;
      }
    `;
    }
};
__decorate([
    property({ type: String })
], IANoTheaterAvailable.prototype, "identifier", void 0);
IANoTheaterAvailable = __decorate([
    customElement('ia-no-theater-available')
], IANoTheaterAvailable);
export { IANoTheaterAvailable };
//# sourceMappingURL=no-theater-available.js.map